import { render, staticRenderFns } from "./AcceptModal.vue?vue&type=template&id=0633237c&scoped=true&"
import script from "./AcceptModal.vue?vue&type=script&lang=js&"
export * from "./AcceptModal.vue?vue&type=script&lang=js&"
import style0 from "./AcceptModal.vue?vue&type=style&index=0&id=0633237c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0633237c",
  null
  
)

component.options.__file = "AcceptModal.vue"
export default component.exports